declare global {
  interface Window {
    isInViewport: typeof isInViewport;
  }
}

export function isInViewport(element) {
  if (element) {
    const specs = element.getBoundingClientRect();
    return (
      specs.top >= 0 &&
      specs.left >= 0 &&
      specs.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      specs.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}

export function truncateToTwoDecimalPlaces(str) {
  let num = parseFloat(str);
  num = Math.trunc(num * 100) / 100;
  return num.toFixed(2);
}

export function convertArrayToTwoDecimalPlaces(arr) {
  return arr.map(truncateToTwoDecimalPlaces);
}

// TODO: legacy support - is this needed? verify where this is used (probably tealium)
window.isInViewport = isInViewport;
